import { DiskTable } from './DiskTable'
export default DiskTable
